import React from 'react';

type ErrorStateProps = {
  compact?: boolean;
  message?: string;
};

export default function ErrorState({ compact, message }: ErrorStateProps) {
  if (compact) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12,
        background: '#fff8f8', border: '1px solid #fde8e8',
        borderRadius: 10, padding: '12px 16px',
      }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#e05252" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600, color: '#c0392b' }}>Something went wrong</div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
            {message || "It's not you, it's us — we'll be back shortly."}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', textAlign: 'center',
      gap: 8, padding: '32px 20px',
    }}>
      <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: 4 }}>
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#64748b' }}>
        Sorry, we ran into a technical issue
      </div>
      <div style={{ fontSize: '0.72rem', color: '#94a3b8', maxWidth: 220, lineHeight: 1.6 }}>
        {message || "It's not you, it's us. We'll be back shortly."}
      </div>
    </div>
  );
}
